<app-top-bar></app-top-bar>

<div class="container">
  <router-outlet></router-outlet>
</div>

<!-- 
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
-->